<div class="app-page">

  <div style="display: flex; flex-wrap: wrap;">
    @for (toplist of _topLists; track toplist) {
      <app-test-top-list-card  [TopList]="toplist" ></app-test-top-list-card>
    }
  </div>
</div>